export default "__VITE_ASSET__DvyE6n5Z__"